<template>
	<IntersectionRoot class="search-list" :threshold="0.75">
		<div
			class="search-item-container pointer"
			v-for="result in results"
			:key="result.message.id"
		>
			<slot :result="result" />
		</div>
		<IntersectionChild
			class="load-more"
			@enter="loadMore"
			v-if="hasMore && results.length"
			:class="{ loading: isLoading }"
		>
			<SpinnerOverlay />
		</IntersectionChild>
	</IntersectionRoot>
</template>

<script>
import {
	IntersectionRoot,
	IntersectionChild,
} from '@/components/common/Intersection'
import SpinnerOverlay from '@/components/SpinnerOverlay'

export default {
	name: 'SearchList',
	props: ['results', 'hasMore'],
	components: { IntersectionRoot, IntersectionChild, SpinnerOverlay },
	data() {
		return { isLoading: false }
	},
	emits: ['load-more'],
	watch: {
		hasMore(hasMore) {
			if (this.isLoading && !hasMore) {
				this.isLoading = false
			}
		},
		results: {
			handler(current, prev) {
				if (current?.length > prev?.length) {
					this.isLoading = false
				}
			},
			deep: true,
		},
	},
	methods: {
		loadMore() {
			this.isLoading = true
			this.$emit('load-more')
		},
	},
}
</script>

<style lang="scss" scoped>
.search-list {
	width: 100%;
	overflow: auto;
	overflow-x: hidden;
	display: flex;
	flex-direction: column;
	padding: 25px 30px;
}
.search-item-container {
	position: relative;
	border: 1px solid #dfdfdf;
	border-radius: 8px;
	background: #fcfcfc;
	margin-bottom: 12px;
	display: flex;
	flex-flow: row wrap;
	&:hover {
		background-color: #f2f4f5;
	}
}

.load-more {
	display: flex;
	align-items: center;
	justify-content: center;
	opacity: 0;
	transition: opacity 0.3s ease-in-out;
	flex-shrink: 0;
	&.loading {
		opacity: 1;
	}
}

:deep(.spinner-div) {
	position: unset;
}
</style>
<style lang="scss">
@import 'src/sass/variables';

@include overrideScheme('dark') {
	.load-more {
		.spinner-div,
		.ios-spinner {
			background-color: var(--neutral-100) !important;
		}
	}
}
</style>
